/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from './tooltip.css.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from 'md2/tooltip/tooltip';
import * as import3 from 'md2/core/rtl/dir';
const styles_Md2TooltipComponent:any[] = [import0.styles];
export const RenderType_Md2TooltipComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 2,
  styles: styles_Md2TooltipComponent,
      data: {'animation': [{
        name: 'state',
        definitions: [
          {
            type: 0,
            name: 'void',
            styles: {
              type: 6,
              styles: {transform: 'scale(0)'}
            }

          }
          ,
          {
            type: 0,
            name: 'initial',
            styles: {
              type: 6,
              styles: {transform: 'scale(0)'}
            }

          }
          ,
          {
            type: 0,
            name: 'visible',
            styles: {
              type: 6,
              styles: {transform: 'scale(1)'}
            }

          }
          ,
          {
            type: 0,
            name: 'hidden',
            styles: {
              type: 6,
              styles: {transform: 'scale(0)'}
            }

          }
          ,
          {
            type: 1,
            expr: '* => visible',
            animation: {
              type: 4,
              styles: (null as any),
              timings: '150ms cubic-bezier(0.0, 0.0, 0.2, 1)'
            }

          }
          ,
          {
            type: 1,
            expr: '* => hidden',
            animation: {
              type: 4,
              styles: (null as any),
              timings: '150ms cubic-bezier(0.4, 0.0, 1, 1)'
            }

          }

        ]

      }
  ]}
}
);
export function View_Md2TooltipComponent_0(l:any):import1.ɵViewDefinition {
      return import1.ɵvid(0,[(l()(),import1.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'md2-tooltip'
      ]
    ],[
      [
        4,
        'transform-origin',
        (null as any)
      ]
      ,
      [
        24,
        '@state',
        0
      ]
      ,
      [
        8,
        'innerHTML',
        1
      ]

    ]
      ,[[
        (null as any),
        '@state.done'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import2.Md2TooltipComponent = v.component;
      if (('@state.done' === en)) {
        const pd_0:any = ((<any>co._afterVisibilityAnimation($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
  },(null as any),(null as any)))],(null as any),(ck,v) => {
    var co:import2.Md2TooltipComponent = v.component;
    const currVal_0:any = co._transformOrigin;
    const currVal_1:any = co._visibility;
    const currVal_2:any = co.message;
    ck(v,0,0,currVal_0,currVal_1,currVal_2);
  });
}
function View_Md2TooltipComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'md2-tooltip',([] as any[]),(null as any),[[
        'body',
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('body:click' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,1)._handleBodyInteraction()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },View_Md2TooltipComponent_0,RenderType_Md2TooltipComponent)),
    import1.ɵdid(49152,(null as any),0,import2.Md2TooltipComponent,[
      [
        2,
        import3.Dir
      ]
      ,
      import1.ChangeDetectorRef
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const Md2TooltipComponentNgFactory:import1.ComponentFactory<import2.Md2TooltipComponent> = import1.ɵccf('md2-tooltip',import2.Md2TooltipComponent,View_Md2TooltipComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3ZlcmNlbC93b3JrcGF0aDAvbm9kZV9tb2R1bGVzL21kMi90b29sdGlwL3Rvb2x0aXAubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vdmVyY2VsL3dvcmtwYXRoMC9ub2RlX21vZHVsZXMvbWQyL3Rvb2x0aXAvdG9vbHRpcC5kLnRzIiwibmc6Ly8vdmVyY2VsL3dvcmtwYXRoMC9ub2RlX21vZHVsZXMvbWQyL3Rvb2x0aXAvdG9vbHRpcC5odG1sIiwibmc6Ly8vdmVyY2VsL3dvcmtwYXRoMC9ub2RlX21vZHVsZXMvbWQyL3Rvb2x0aXAvdG9vbHRpcC5kLnRzLk1kMlRvb2x0aXBDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8ZGl2IGNsYXNzPVwibWQyLXRvb2x0aXBcIiBbc3R5bGUudHJhbnNmb3JtLW9yaWdpbl09XCJfdHJhbnNmb3JtT3JpZ2luXCIgW0BzdGF0ZV09XCJfdmlzaWJpbGl0eVwiIChAc3RhdGUuZG9uZSk9XCJfYWZ0ZXJWaXNpYmlsaXR5QW5pbWF0aW9uKCRldmVudClcIiBbaW5uZXJIVE1MXT1cIm1lc3NhZ2VcIj48L2Rpdj4iLCI8bWQyLXRvb2x0aXA+PC9tZDItdG9vbHRpcD4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OzZCQ0FBO1FBQUE7UUFBQTtNQUFBO0lBQUE7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7TUFBQTtNQUFBO01BQTRGO1FBQUE7UUFBQTtNQUFBO01BQTVGO0VBQUE7O0lBQXlCO0lBQTRDO0lBQXlFO0lBQTlJLFNBQXlCLFVBQTRDLFVBQXlFLFNBQTlJOzs7OztNQ0FBO1FBQUE7UUFBQTtNQUFBO0lBQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO01BQUE7SUFBQTtnQkFBQTtNQUFBO1FBQUE7O01BQUE7OztJQUFBO0tBQUE7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/~/md2/tooltip/tooltip.ngfactory.ts